<template>
  <!-- 布局-->
  <div>
    <Head />
    <router-view />

    <!-- contact -->
    <Contact />

    <!-- foot -->
    <Foot />

    <div id="toTop" @click="top">
      <span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span>
    </div>
  </div>
</template>

<script>
import Head from "./components/head.vue";
import Contact from "./components/contact";
import Foot from "./components/foot";

export default {
  name: "Layout",
  data() {
    return {};
  },
  components: {
    Head,
    Contact,
    Foot,
  },
  computed: {},
  methods: {
    top() {
      window.$("body,html").animate(
        {
          scrollTop: 0,
        },
        "slow"
      );
    },
  },
  mounted() {
    window.$(window).scroll(function () {
      let h = window.$(window).scrollTop();
      if (h > 600) {
        window.$("#toTop").fadeIn(200);
      } else {
        window.$("#toTop").fadeOut(200);
      }
    });
  },
};
</script>

<style scoped>
#toTop {
  display: none;
  width: 40px;
  height: 40px;
  background-color: #2f56ce;
  border: 1px solid #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
}
.mb #toTop {
  bottom: 10px;
  right: 10px;
}
</style>
